import _pick from 'lodash/pick';

export const pickFormValuesFromProps = keys => props => _pick(props, keys);